/*
 * pp-cookie-banner.js — Lógica de consent para LFPDPPP.
 *
 * Si ya hay consent en localStorage → no mostrar.
 * Si no → mostrar después de 500ms (no quema LCP).
 *
 * Botones:
 *   - "Aceptar todo"    → consent = 'all'       → Shopify: los 4 propósitos en true
 *   - "Solo necesarias" → consent = 'necessary' → Shopify: los 4 en false
 *     (los web pixels de Google, Meta y TikTok los carga SHOPIFY, no el tema;
 *     por eso la elección va a la Customer Privacy API — ver avisarAShopify)
 *   La identidad PROPIA (pp_visitor_key, Paco, sesión de cliente) NO depende
 *   de la elección. Cada elección se cuenta anónima (contarEleccion).
 *
 * El usuario puede reabrir el banner con:
 *   window.ppCookieConsent.reopen()
 *
 * Otros scripts pueden leer:
 *   window.ppCookieConsent.value  → 'all' | 'necessary' | null
 *   window.ppCookieConsent.granted('analytics')  → boolean
 *
 * Y escuchar cambios:
 *   document.addEventListener('pp:cookie-consent', (e) => {...})
 */
(function () {
  'use strict';

  var KEY = 'pp_cookie_consent';
  var KEY_AT = 'pp_cookie_consent_at';
  // IDENTIDAD PROPIA (5-oct-2026, decisión del dueño): reconocer que «esta
  // persona es esta persona» para atenderla mejor NO depende de este aviso.
  // pp_visitor_key (lo crea pp-visitor-tracking.js), la sesión de Paco y la
  // sesión de cliente de Shopify funcionan igual con «Aceptar todo», con
  // «Solo necesarias» y sin elegir. Lo que «Solo necesarias» apaga es la
  // publicidad y la analítica de TERCEROS (ver avisarAShopify).
  //
  // Hasta hoy «Solo necesarias» escribía pp_tracking_optout=1 y BORRABA
  // pp_visitor_key — contrato heredado del banner viejo pp-consent-banner
  // (retirado 2-sep-2026). Medido en vivo: desde la página siguiente el
  // visitante dejaba de existir para el CRM y Paco perdía el visitor_key. Ese
  // contrato se retira: ningún lector lo consulta ya, y aquí sólo se limpia
  // la llave vieja de quien la traiga (tests/identidad-propia-no-depende-del-aviso).
  var KEY_OPTOUT_VIEJO = 'pp_tracking_optout';

  function limpiarOptOutViejo() {
    try { localStorage.removeItem(KEY_OPTOUT_VIEJO); } catch (e) { /* incognito */ }
  }

  // ── Customer Privacy API de Shopify (5-oct-2026) ─────────────────────────
  // Hasta hoy la elección sólo vivía en localStorage y NADIE la leía: con
  // «Solo necesarias» seguían cargando y mandando datos Google (Ads + GA4),
  // Meta y TikTok, porque los web pixels de las apps obedecen el consentimiento
  // de SHOPIFY, no el nuestro (en México Shopify lo da por concedido).
  // Ahora la elección se le pasa a Shopify con setTrackingConsent:
  //   «Aceptar todo»    → los cuatro propósitos en true (igual que hoy).
  //   «Solo necesarias» → los cuatro en false: Shopify frena los pixels.
  // Sin elección NO se llama a la API (opt-out, LFPDPPP): todo sigue igual.
  // Doc: https://shopify.dev/docs/api/customer-privacy (loadFeatures +
  // setTrackingConsent + currentVisitorConsent, que devuelve 'yes'|'no'|'').
  var PROPOSITOS = ['analytics', 'marketing', 'preferences', 'sale_of_data'];

  function consentimientoShopify(value) {
    if (value !== 'all' && value !== 'necessary') return null;
    var c = {};
    PROPOSITOS.forEach(function (k) { c[k] = value === 'all'; });
    return c;
  }

  function conPrivacidad(cb) {
    var S = window.Shopify;
    if (S && S.customerPrivacy) { cb(S.customerPrivacy); return; }
    if (!S || typeof S.loadFeatures !== 'function') return;
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) return;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp) cb(cp);
    });
  }

  // ¿Shopify ya tiene ESTA elección? currentVisitorConsent: 'yes' | 'no' | ''.
  function shopifyYaLaTiene(cp, value) {
    var esperado = value === 'all' ? 'yes' : 'no';
    var actual;
    try { actual = cp.currentVisitorConsent() || {}; } catch (e) { return false; }
    return actual.analytics === esperado && actual.marketing === esperado;
  }

  // soloSiFalta: al cargar la página con una elección guardada (de antes de
  // esta versión, o de otro dominio/cookie borrada) se sincroniza sólo si
  // Shopify no la tiene — no se re-escribe en cada página.
  function avisarAShopify(value, soloSiFalta) {
    var c = consentimientoShopify(value);
    if (!c) return;
    conPrivacidad(function (cp) {
      if (typeof cp.setTrackingConsent !== 'function') return;
      if (soloSiFalta && shopifyYaLaTiene(cp, value)) return;
      try { cp.setTrackingConsent(c, function () {}); } catch (e) { /* la API cambió: no romper el aviso */ }
    });
  }

  var banner = document.querySelector('[data-pp-cookie-banner]');
  if (!banner) return;

  function read() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      localStorage.setItem(KEY, value);
      localStorage.setItem(KEY_AT, new Date().toISOString());
    } catch (e) { /* incognito o storage lleno */ }
  }

  // Alto del aviso para quien deba librarlo (el botón de Paco en escritorio:
  // pp-assistant.css lo sube por encima mientras el aviso está visible; antes
  // lo tapaba y en la primera visita no se podía picar). Cambia al envolver
  // el texto, así que se mide al mostrar y al cambiar el ancho.
  var root = document.documentElement;
  function medirAlto() {
    if (!banner.classList.contains('is-visible')) return;
    root.style.setProperty('--pp-cookie-banner-alto', banner.offsetHeight + 'px');
    // Ficha en celular (Dirección, 24-oct-2026): el aviso va apilado JUSTO
    // ARRIBA de la barra de compra, sin taparla. Se mide su orilla real.
    // TM-1 (26-oct-2026): fuera de la ficha, igual con la barra de abajo
    // (Inicio/Menú/Chat): la tapaba 56 px y costaba un toque antes de todo.
    // Sólo si se pinta (en escritorio está en display:none y mide 0).
    var barra = document.querySelector('.template-product .pp-fab-barra, .template-product .pp-main-product__sticky');
    if (!barra) {
      var mtb = document.querySelector('.pp-mtb');
      if (mtb && mtb.offsetHeight > 0) barra = mtb;
    }
    if (barra) root.style.setProperty('--pp-cookie-banner-bottom', Math.max(0, Math.round(window.innerHeight - barra.getBoundingClientRect().top)) + 'px');
    else root.style.removeProperty('--pp-cookie-banner-bottom');
    banner.classList.toggle('pp-cookie-banner--apilado', !!barra);
  }

  function show() {
    // Sin animación: se ve en cuanto deja de estar `hidden` (24-oct-2026).
    banner.hidden = false;
    banner.classList.add('is-visible');
    medirAlto();
    window.addEventListener('resize', medirAlto, { passive: true });
  }

  function hide() {
    banner.classList.remove('is-visible');
    window.removeEventListener('resize', medirAlto);
    root.style.removeProperty('--pp-cookie-banner-alto');
    root.style.removeProperty('--pp-cookie-banner-bottom');
    banner.hidden = true;
  }

  function broadcast(value) {
    document.dispatchEvent(new CustomEvent('pp:cookie-consent', {
      detail: { value: value }
    }));
  }

  // ── Contador ANÓNIMO de elecciones (5-oct-2026, aprobado por el dueño) ──
  // Al elegir, UNA llamada a track-event con { event_type: 'cookie_choice',
  // eleccion } — sin visitor_key, sin nada que identifique. Monorepo:
  // public.cookie_elecciones_diarias (una fila por día y elección). No
  // bloquea el aviso (beacon, fire-and-forget) y no reintenta: sólo si el
  // navegador NO encoló el beacon va un fetch keepalive, una vez. Repetir la
  // misma elección no cuenta (no es una decisión nueva).
  var URL_CONTEO = typeof banner.getAttribute === 'function'
    ? banner.getAttribute('data-pp-cookie-conteo-url') : null;

  function contarEleccion(value) {
    if (!URL_CONTEO || (value !== 'all' && value !== 'necessary')) return;
    var body = JSON.stringify({ event_type: 'cookie_choice', eleccion: value });
    var encolado = false;
    try {
      if (navigator.sendBeacon) {
        encolado = navigator.sendBeacon(URL_CONTEO, new Blob([body], { type: 'text/plain' }));
      }
    } catch (e) { encolado = false; }
    if (encolado) return;
    try { fetch(URL_CONTEO, { method: 'POST', body: body, keepalive: true }).catch(function () {}); } catch (e) { /* sin red: no se cuenta */ }
  }

  function accept(value) {
    var antes = read();
    write(value);
    limpiarOptOutViejo();
    avisarAShopify(value, false);
    hide();
    broadcast(value);
    if (antes !== value) contarEleccion(value);
  }

  // Expose API global para otros scripts y para reabrir manual
  window.ppCookieConsent = {
    get value() { return read(); },
    granted: function (category) {
      var v = read();
      if (v === 'all') return true;
      if (v === 'necessary') {
        // Por ahora 'necessary' = bloquea analytics y marketing
        return false;
      }
      return false;
    },
    reopen: show,
    accept: accept
  };

  // Bind botones
  banner.querySelectorAll('[data-pp-cookie-accept]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      accept(btn.getAttribute('data-pp-cookie-accept'));
    });
  });

  // Quien eligió «Solo necesarias» antes del 5-oct-2026 (o «No rastrear» en
  // el banner viejo) trae el opt-out puesto: se limpia en cada carga.
  limpiarOptOutViejo();

  // Mostrar si no hay consent guardado
  if (!read()) {
    setTimeout(show, 500);
  } else {
    // Si ya hay consent, broadcastearlo on load y re-sincronizar Shopify.
    avisarAShopify(read(), true);
    broadcast(read());
  }
})();
